import { FC, Fragment, useMemo, useState } from 'react';

import AutTable from '../../blocks/aut-grid-table';
import PMIResultElementForm from '../../forms/custom-pmi/pmiResultElementForm';

interface DRTelementsProps {
    elements: string[];
    onDataChange: (elements: string[]) => void;
}

const PMIResultElements: FC<DRTelementsProps> = (props) => {
    const [elementToEdit, setElementToEdit] = useState('');

    const elements = useMemo(() => {
        return props.elements.map((element) => ({
            name: element,
        }));
    }, [props.elements]);

	const handleAddItem = (element: string) => {
		props.onDataChange([...props.elements, element]);
	};

	const handleDeleteItem = (elementToDelete: string): void => {
		const newElements = props.elements.filter((element) => element !== elementToDelete);
		props.onDataChange(newElements);
	};
	
    const handleEditItem = (newElement: string): void => {
        const newElements = props.elements.map((element) => element === elementToEdit ? newElement : element);
		props.onDataChange(newElements);
        setElementToEdit('');
	};

	return (
		<Fragment>
            {elementToEdit ? (
                <PMIResultElementForm
                    element={elementToEdit}
                    elements={props.elements}
                    onSaveElement={handleEditItem}
                    onCancelEdit={() => setElementToEdit('')}
                />
            ) : (
                <PMIResultElementForm
                    elements={props.elements}
                    onSaveElement={handleAddItem}
                />
            )}

			<div className="divider my-4"></div>

			<AutTable
				data={elements}
				tableColumns={columns}
				onDeleteItem={(item) => handleDeleteItem(item.name)}
                onEditItem={(item) => setElementToEdit(item.name)}
			/>
		</Fragment>
	);
};

const columns = [
    {
        path: 'name',
        label: 'Element Name',
    },
];

export default PMIResultElements;
